<app-tenant-form [response]="response" (onSubmitCallback)="onSubmit($event[0])"></app-tenant-form>
